import { Injectable } from '@angular/core';
import { map, firstValueFrom } from 'rxjs';
import { ProjecaoOfertaMatriculas } from '../../dtos';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../'
import { LocalizacaoService } from '../localizacao/localizacao.service';
import { TipoSimulacao } from '../../enums/simulation-type.enum';

interface ListMatriculasPorEscola {
  diagnosticos: ProjecaoOfertaMatriculas[];
}

@Injectable({
  providedIn: 'root'
})
export class MatriculasPorEscolaService {

  private baseApiUrl = `${environment.apiUrl}/diagnostico-de-matricula-de-escola`;

  constructor(
    private caqRequestService: CaqRequestService,
    private localizacaoService: LocalizacaoService
  ) { }

  buscarMatriculasPorEscola(): Promise<ProjecaoOfertaMatriculas[]> {
    const localizacao = this.localizacaoService.obterLocalizacaoSelecionada();
    const tipoSimulacao = this.localizacaoService.obterTipoSimulacao();

    if (!localizacao || !localizacao.cidadeSelecionada) {
      return Promise.reject('Localização municipal não selecionada');
    }

    const codMun = localizacao.cidadeSelecionada.value;
    let endpoint = '';

    if (tipoSimulacao === TipoSimulacao.planejamento) {
      endpoint = `${this.baseApiUrl}/plano-municipal/${codMun}`;
    } else if (tipoSimulacao === TipoSimulacao.planejamentoPorEsferaAdmMunicipal) {
      endpoint = `${this.baseApiUrl}/rede-municipal/${codMun}`;
    } else {
      return Promise.reject('Tipo de simulação não suportado para matrículas por escola');
    }

    return firstValueFrom(
      this.caqRequestService
        .get<ListMatriculasPorEscola>(endpoint)
        .pipe(map((response) => response.diagnosticos || []))
    );
  }
}

